import React from 'react'
import {Button, ButtonPriority} from 'wix-ui-tpa/cssVars'
import classNames from 'classnames'
import {classes} from './secondary-button.st.css'
import {SecondaryButtonProps} from './index'

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  onClick,
  className,
  mobile,
  dataHook,
  narrowerButton,
  children,
}) => {
  return (
    <Button
      upgrade
      priority={ButtonPriority.basicSecondary}
      className={classNames(classes.root, className, {
        [classes.mobile]: mobile,
        [classes.narrowerButton]: narrowerButton,
      })}
      onClick={onClick}
      data-hook={dataHook}
    >
      {children}
    </Button>
  )
}
